module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtitled",
    attrs: {
      "id": "Maps"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexviii",
      "title": "xviii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maps")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pagevl1_xviii-1.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "figcapbox"
  }, [_c('p', {
    staticClass: "fcaption",
    attrs: {
      "id": "figurexviii-1"
    }
  }, [_vm._v("Indochina. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pagevl1_xix-1.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "figcapbox"
  }, [_c('p', {
    staticClass: "fcaption",
    attrs: {
      "id": "figurexix-1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexix",
      "title": "xix"
    }
  }, [_vm._v("North Vietnam. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pagevl1_xx-1.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "figcapbox"
  }, [_c('p', {
    staticClass: "fcaption",
    attrs: {
      "id": "figurexx-1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexx",
      "title": "xx"
    }
  }, [_vm._v("South Vietnam. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pagevl1_xxi-1.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "figcapbox"
  }, [_c('p', {
    staticClass: "fcaption",
    attrs: {
      "id": "figurexxi-1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexxi",
      "title": "xxi"
    }
  }, [_vm._v("Area of Operations 1st Infantry Division. (David Rennie, from original sketches by Colonel (Ret) William C. Haponski)"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexxii",
      "title": "xxii"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d91e60f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Maps.vue
// module id = 87
// module chunks = 0